import { DefaultChartKeyFields, FormErrorText } from './constant'

export class ChartUtility {
    static calculateBarWidth = (totalWidth, dataLength) => {
        return totalWidth / (dataLength * 2)
    }

    static groupByTemplate = data => {
        if (!data?.length) {
            return []
        }
        const list = {}
        data.map(ele => {
            const newList = list[ele.TemplateData.OriginalTemplateId] || []
            list[ele.TemplateData.OriginalTemplateId] = [...newList, ele]
            return null
        })
        return Object.values(list)
    }

    static withoutScoreChartList = listData => {
        const list = []
        let keys = []
        listData?.map(ele => {
            if (
                ele.withoutScoreData &&
                Object.keys(ele.withoutScoreData).length
            ) {
                list.push({
                    SectionName: ele.SectionName,
                    ...ele.withoutScoreData,
                })
                keys.push(
                    ...Object.keys(ele.withoutScoreData).filter(
                        ele => ele !== DefaultChartKeyFields.unAnswered,
                    ),
                )
            }
            return ''
        })
        keys = Array.from(new Set([...keys]))
        keys.push(DefaultChartKeyFields.unAnswered)
        return { list: list || [], keys: keys || [] }
    }

    static byNCChartList = listData => {
        const list = []
        listData.forEach(section => {
            let nc = 0

            section.questions?.forEach(question => {
                // Handle MultipleResponse
                const multipleResponseNC =
                    question.Answers.MultipleResponse?.some(
                    ql => ql.IsSelected && ql.DisplayText === 'No',
                    )

                // Handle ParentChildResponse
                const parentChildResponseNC =
                    question.Answers.ParentChildResponse?.some(
                        parent =>
                            parent.IsSelected &&
                            !parent.Children?.some(child => child.IsSelected),
                    )

                if (multipleResponseNC || parentChildResponseNC) {
                    nc += 1
                }
            })

            if (nc > 0) {
                list.push({
                    name: section.SectionName,
                    NC: nc,
                })
            }
        })
        return list
    }

    static byCommulativeNCChartList = listData => {
        const list = {}
        listData.forEach(section => {
            if ((section.questions || []).length > 0) {
                section.questions.forEach(question => {
                    const temp = question.Answers.MultipleResponse?.some(
                        ql => ql.IsSelected && ql.DisplayText === 'No',
                    )
                    if (temp) {
                        if (!list[question.FAQ]) {
                            list[question.FAQ] = 1
                        } else {
                            list[question.FAQ] += 1
                        }
                    }
                })
            }
        })
        return Object.entries(list)
            .sort(([, a], [, b]) => b - a) // Sort by value in descending order
            .slice(0, 5)
            .map(([name, nc]) => ({ name, NC: nc }))
    }

    static getWithoutChartQuestionResult = (questions, totalQuestions) => {
        let data = {}
        let given = 0
        const group = {}
        const filledSections = {}

        questions.map(ele => {
            // Handle MultipleResponse
            ele.Answers.MultipleResponse?.map(ql => {
                if (ql.IsSelected) {
                    given += 1
                    if (group[ql.DisplayText]) {
                        group[ql.DisplayText] += 1
                    } else {
                        group[ql.DisplayText] = 1
                    }
                }
                return null
            })

            // Handle ParentChildResponse
            if (ele.Answers.ParentChildResponse?.length) {
                ele.Answers.ParentChildResponse.map(parent => {
                    if (parent.IsSelected) {
                        given += 1
                        const parentText = `${parent.ParentName} (Parent)`
                        if (group[parentText]) {
                            group[parentText] += 1
                        } else {
                            group[parentText] = 1
                        }

                        // Handle selected child
                        const selectedChild = parent.Children?.find(
                            child => child.IsSelected,
                        )
                        if (selectedChild) {
                            given += 1
                            const childText = `${selectedChild.ChildName} (Child)`
                            if (group[childText]) {
                                group[childText] += 1
                            } else {
                                group[childText] = 1
                            }
                        }
                    }
                    return null
                })
            }

            return null
        })

        const filledPercentage = (given / totalQuestions) * 100
        Object.keys(group).map(key => {
            filledSections[key] = (group[key] / given) * 100
            filledSections[key] = (
                (filledSections[key] * filledPercentage) /
                100
            ).toFixed(2)
            return ''
        })

        const remain = 100 - filledPercentage
        data = {
            ...filledSections,
            [DefaultChartKeyFields.unAnswered]:
                remain <= 0 ? undefined : remain.toFixed(2),
        }
        return data
    }

    static withoutScoreDataResult = list => {
        const sections = {}
        list.map(val => {
            const questions = [
                ...(sections?.[val.SectionId]?.questions || []),
                ...this.questionUtils(val.Questions).questions,
            ]
            const totalQuestions =
                (sections[val.SectionId]?.totalQuestions || 0) +
                val.Questions.length
            sections[val.SectionId] = {
                ...this.getSectionData(val),
                withoutScoreData: {
                    ...this.getWithoutChartQuestionResult(
                        questions,
                        totalQuestions,
                    ),
                },
            }
            return null
        })
        return sections
    }

    static getSectionData = data => {
        return {
            SectionName: data.SectionName.trim(FormErrorText.SpacesNotAllowed),
            SectionId: data.SectionId,
            Order: data.Order,
        }
    }

    static getSectionResult = data => {
        console.log('getSectionResult - Input data:', data)

        if (!data?.length) {
            console.log('getSectionResult - No data received')
            return []
        }

        const sections = {}
        data.map(val => {
            console.log('Processing section:', val.SectionName)
            console.log('Section Questions:', val.Questions)

            const { filled, rightAnswer, questions } = this.questionUtils(
                val.Questions,
            )
            console.log('questionUtils result:', {
                filled,
                rightAnswer,
                questions,
            })

            // Include sections that have any type of answer
            const hasAnswers = val.Questions.some(q => {
                const hasParentChild = q.Answers.ParentChildResponse?.some(
                    p => p.IsSelected || p.Children?.some(c => c.IsSelected),
                )
                const hasMultiple = q.Answers.MultipleResponse?.some(
                    m => m.IsSelected,
                )

                console.log('Question answers check:', {
                    questionId: q.Id,
                    hasParentChild,
                    hasMultiple,
                    parentChildResponses: q.Answers.ParentChildResponse,
                    multipleResponses: q.Answers.MultipleResponse,
                })

                return hasParentChild || hasMultiple
            })

            console.log('Section has answers:', hasAnswers)

            if (hasAnswers) {
                sections[val.SectionId] = {
                    ...this.getSectionData(val),
                    filled: filled || 0,
                    rightAnswer: rightAnswer || 0,
                    percentage: parseInt(
                        ((rightAnswer / (filled || 1)) * 100).toFixed(2),
                        10,
                    ),
                    questions: val.Questions,
                }
                console.log(
                    'Added section to results:',
                    sections[val.SectionId],
                )
            }
            return null
        })

        console.log('Final sections before total:', sections)

        if (Object.keys(sections).length > 0) {
        sections.total = this.getGeneralResult(sections)
            console.log('Added total section:', sections.total)
        }

        console.log('Final sections result:', sections)
        return sections
    }

    static getGeneralResult = list => {
        let totalPercentage = 0
        let sectionCount = 0

        Object.values(list).forEach(ele => {
            if (
                ele.SectionName !== 'General Result' &&
                !Number.isNaN(ele.percentage)
            ) {
                totalPercentage += ele.percentage
                sectionCount += 1
            }
        })

        const averagePercentage =
            sectionCount > 0 ? totalPercentage / sectionCount : 0

        return {
            SectionName: 'General Result',
            SectionId: '0',
            TemplateName: '',
            percentage: parseInt(averagePercentage, 10),
            rightAnswer: 0,
            filled: 0,
            Order: 500,
        }
    }

    static formatParentChildResponseForReport = parentChildResponse => {
        if (!parentChildResponse?.length) return []

        return parentChildResponse
            .map(parent => {
                // Format parent response
                const parentOption = {
                    DisplayText: parent.ParentName,
                    IsSelected: parent.IsSelected,
                    Score: 0, // Adjust if you have scoring for parents
                    IsParent: true,
                }

                // Format child responses (indented)
                const childOptions =
                    parent.Children?.map(child => ({
                        DisplayText: `    ${child.ChildName}`, // Indent child options
                        IsSelected: child.IsSelected,
                        Score: 0, // Adjust if you have scoring for children
                        IsChild: true,
                    })) || []

                return [parentOption, ...childOptions]
            })
            .flat()
    }

    static questionUtils = questions => {
        console.log('questionUtils - Processing questions:', questions?.length)

        const questionsData = {
            questions: [],
            filled: 0,
            rightAnswer: 0,
        }

        questions?.forEach(qa => {
            console.log('Processing question:', {
                id: qa.Id,
                type: qa.TypeOfResponse,
                hasParentChild: Boolean(qa.Answers.ParentChildResponse?.length),
                hasMultiple: Boolean(qa.Answers.MultipleResponse?.length),
            })

            // Handle ParentChildResponse
            if (qa.Answers.ParentChildResponse?.length) {
                qa.Answers.ParentChildResponse.forEach(parent => {
                    console.log('ParentChildResponse:', {
                        parentName: parent.ParentName,
                        isSelected: parent.IsSelected,
                        selectedChildren: parent.Children?.filter(
                            c => c.IsSelected,
                        )?.length,
                    })

                    if (parent.IsSelected) {
                        questionsData.filled += 1
                        const hasSelectedChild = parent.Children?.some(
                            child => child.IsSelected,
                        )
                        if (hasSelectedChild) {
                            questionsData.filled += 1
                            questionsData.rightAnswer += 1
                        }
                    }
                })
            }

            // Handle MultipleResponse
            if (qa.Answers.MultipleResponse?.length) {
                qa.Answers.MultipleResponse.forEach(mlQ => {
                    console.log('MultipleResponse:', {
                        text: mlQ.DisplayText,
                        isSelected: mlQ.IsSelected,
                        score: mlQ.Score,
                    })

                    if (
                        mlQ.DisplayText === 'NOT APPLICABLE' &&
                        mlQ.IsSelected
                    ) {
                        return
                    }
                    if (mlQ.IsSelected) {
                        questionsData.filled += 1
                        if (mlQ.Score) {
                        questionsData.rightAnswer += 1
                        }
                    }
                })
            }

            if (questionsData.filled > 0) {
                questionsData.questions.push(qa)
            }
        })

        console.log('questionUtils - Final result:', questionsData)
        return questionsData
    }

    static getGroupedForChart = data => {
        console.log('getGroupedForChart - Initial data:', data)

        if (!data?.length) {
            console.log('getGroupedForChart - No data received')
            return []
        }

        const sections = {}
        data.map(ele => {
            console.log('Processing template data:', ele.TemplateData)

            ele?.TemplateData?.Sections?.map(val => {
                console.log('Processing section:', {
                    sectionName: val.SectionName,
                    questions: val.Questions,
                })

                const questionsData = this.questionUtils(val.Questions)
                console.log('questionUtils result:', questionsData)

                const filled =
                    (sections[val.SectionId]?.filled || 0) +
                    questionsData.filled
                const rightAnswer =
                    (sections[val.SectionId]?.rightAnswer || 0) +
                    questionsData.rightAnswer

                console.log('Calculated values:', {
                    filled,
                    rightAnswer,
                    sectionId: val.SectionId,
                })

                const questions = [
                    ...(sections?.[val.SectionId]?.questions || []),
                    ...questionsData.questions,
                ]

                const totalQuestions =
                    (sections[val.SectionId]?.totalQuestions || 0) +
                    val.Questions.filter(qa => {
                        const isNotApplicable =
                            qa.Answers.MultipleResponse?.some(
                                ql =>
                                    ql.DisplayText === 'NOT APPLICABLE' &&
                                    ql.IsSelected,
                            )
                        console.log('Question applicability check:', {
                            questionId: qa.Id,
                            isNotApplicable,
                        })
                        return !isNotApplicable
                    }).length

                const percentage = parseInt(
                    ((rightAnswer / filled) * 100 || 0).toFixed(2),
                    10,
                )
                console.log('Section percentage:', percentage)

                if (filled !== 0 && percentage !== 0) {
                    sections[val.SectionId] = {
                        ...this.getSectionData(val),
                        SectionName: val.SectionName.trim(
                            FormErrorText.SpacesNotAllowed,
                        ),
                        filled,
                        rightAnswer,
                        SectionId: val.SectionId,
                        Order: val.Order,
                        TemplateName: ele.TemplateData.AuditName,
                        percentage,
                        questions,
                        totalQuestions,
                        withoutScoreData: {
                            ...this.getWithoutChartQuestionResult(
                                questions,
                                totalQuestions,
                            ),
                        },
                    }
                    console.log('Added section:', sections[val.SectionId])
                } else {
                    console.log('Section skipped - no valid answers:', {
                        sectionId: val.SectionId,
                        filled,
                        percentage,
                    })
                }
                return null
            })
            return null
        })

        console.log('Final sections before total:', sections)
        sections.total = this.getGeneralResult(sections)
        console.log('Final result with total:', sections)

        return Object.values(sections).sort((a, b) => a - b)
    }

    static formatResponseForDisplay = question => {
        if (question.Answers.ParentChildResponse?.length) {
            const responses = []
            question.Answers.ParentChildResponse.forEach(parent => {
                // Add parent option
                responses.push(
                    `[ ${parent.IsSelected ? 'X' : ' '} ] ${parent.ParentName}`,
                )

                // Add child options with indentation
                parent.Children?.forEach(child => {
                    responses.push(
                        `    [ ${child.IsSelected ? 'X' : ' '} ] ${
                            child.ChildName
                        }`,
                    )
                })
            })
            return responses.join('\n')
        }

        if (question.Answers.MultipleResponse?.length) {
            return question.Answers.MultipleResponse.map(
                response =>
                    `[ ${response.IsSelected ? 'X' : ' '} ] ${
                        response.DisplayText
                    }`,
            ).join('\n')
        }

        return ''
    }
}
